// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"61529532","34":"ad0e1185","204":"088bc579","453":"85b82d39","456":"64944a15","769":"3ed932db","815":"854ad8d4"}[chunkId] + ".chunk.js";
};